import type Paginated from 'app/core/paginable';
import { useGetApplication } from 'app/hooks';
import { baseUrlTaxreturns } from 'app/modules/Reports/TaxReturnList/http';
import { type TaxReturn } from 'app/modules/Reports/TaxReturnList/types';
import { type ResponseValues } from 'axios-hooks';
import moment from 'moment';

import { type TaxReturnPayment } from '../models/Payment';

const idWithoutData = '01660e23-d782-40f3-9c67-6c0537f64aa9';
const BaseUrlTaxReturnPayment = '/taxreturnpayments';

export const useGetTaxreturnByCurrentTaxpayer = (id: string) => {
  const taxreturnId = id ? id : idWithoutData;
  const [{ data, loading, error }] = useGetApplication<Paginated<TaxReturn>>({
    url: `${baseUrlTaxreturns}`,
    params: { page: 1, pageSize: 1, id: taxreturnId, relations: ['FormVersion.Form'] }
  });

  const [taxreturn] = data?.data || [];
  return { loading, error, taxreturn };
};

const defaultRelations = [
  'Currency',
  'PaymentMethod',
  'TaxReturn',
  'TaxReturn.Taxpayer',
  'ReconciliationOfPayments.PaymentsReceived.PaymentReceived'
];
export const useGetTaxreturnPaymentByCurrentTaxpayer = (
  id: string,
  valor?: string
): ResponseValues<TaxReturnPayment, any, any> => {
  const paymentId = id ? id : idWithoutData;

  const [{ data, loading, error }] = useGetApplication<Paginated<TaxReturnPayment>>({
    url: `${BaseUrlTaxReturnPayment}`,
    params: { page: 1, pageSize: 1, id: paymentId, relations: defaultRelations, valor }
  });

  const [payment] = data?.data || [];
  return {
    loading,
    error,
    data: (payment
      ? {
          ...payment,
          createdDate: moment(payment.createdDate).toDate()
        }
      : undefined) as TaxReturnPayment
  } as ResponseValues<TaxReturnPayment, any, any>;
};
